module.exports = __webpack_public_path__ + "img/Etebar-gary.42cadec.png";